import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { getCountryValueFromKey } from '../../../../helpers/countryHelper';
import { withStyles } from '@material-ui/core/styles';
import HpTooltip from '../../../../components/shared/components/hpTooltip';
import { contentTypes } from '../../../../constants';

const styles = theme => ({
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '40px'
  },
  image: {
    maxWidth: '100px',
    maxHeight: '100px',
    borderRadius: '100px',
    marginRight: '20px'
  },
  paragraph: {
    marginTop: '30px'
  },
  propertyItem: {
    width: '100px',
    display: 'inline-block',
    marginTop: '50px'
  },
  brandStoryContainer: {
    marginTop: '30px'
  },
  goalsContainer: {
    marginTop: '30px'
  },
  productPhoto: {
    maxHeight: '250px',
    maxWidth: '250px',
    borderRadius: '200px'
  },
  productContainer: {
    marginTop: '20px',
    textAlign: 'center',
    color: 'black!important',
    textDecoration: 'underline!important'
  }
});

class CampaignReview extends React.Component {
  constructor() {
    super();

    this.state = {
      currentDate: moment()
    };
  }

  render() {
    const {
      classes,
      campaignInfo,
      backButtonClick,
      saveCampaignClick,
      profile
    } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.root}>
          <Grid container direction="column">
            <Grid container direction="row">
              <Grid item sm={8}>
                <Grid container direction="row">
                  <img
                    src={profile.profilePictureUrl}
                    className={classes.image}
                  />
                  <div>
                    <Typography variant="h5">{campaignInfo.name}</Typography>
                    <Typography>
                      Created on {this.state.currentDate.format('MM/DD/YYYY')}{' '}
                      by {profile.displayName}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid />
            <Grid item sm={12} className={classes.paragraph}>
              <Typography variant="body1" className={classes.paragraph}>
                {campaignInfo.description}
              </Typography>
              {campaignInfo.contentType === contentTypes.OTHER && (
                <React.Fragment>
                  <Typography variant="h6" className={classes.paragraph}>
                    Custom Content Requirement:
                  </Typography>
                  <Typography variant="body1">
                    {campaignInfo.otherContentDetails}
                  </Typography>
                </React.Fragment>
              )}
            </Grid>
            <Grid container direction="row">
              {campaignInfo.contentType && (
                <Grid sm={2} className={classes.propertyItem} align="center">
                  {campaignInfo.contentType === contentTypes.REVIEW && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Review
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to revewing your experience with the product or service.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaignInfo.contentType === contentTypes.GAMEPLAY && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Gameplay
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video of you playing the game and giving your own positive commentary.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaignInfo.contentType === contentTypes.MENTION && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Mention
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'An endorsement during a video encouraging viewers to use the service, buy the product, or check out the website.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaignInfo.contentType === contentTypes.TUTORIAL && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Mention
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to walking viewers through how to use the product or service and why they should buy it.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaignInfo.contentType === contentTypes.UNBOXING && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Unboxing
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to giving a first impression of unpacking the product on camera and why the viewer should buy it.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaignInfo.contentType === contentTypes.OTHER && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Other
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={'See above for description of the content.'}
                      />
                    </React.Fragment>
                  )}
                  <Typography variant="body1">Content Type</Typography>
                </Grid>
              )}
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.ageMin} - {campaignInfo.ageMax}
                </Typography>
                <Typography variant="body1">Ages</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {`$${parseFloat(
                    campaignInfo.payoutMin
                  ).toLocaleString()} - $${parseFloat(
                    campaignInfo.payoutMax
                  ).toLocaleString()}`}
                </Typography>
                <Typography variant="body1">Payout</Typography>
              </Grid>

              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {(campaignInfo.productAndCommission ||
                    campaignInfo.productOnly) &&
                    `Yes`}
                  {!campaignInfo.productAndCommission &&
                    !campaignInfo.productOnly &&
                    'No'}
                </Typography>
                <Typography variant="body1">Recieve Product</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.shippableProduct && `Yes`}
                  {!campaignInfo.shippableProduct && 'No'}
                </Typography>
                <Typography variant="body1">Shippable Product</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.duration && `${campaignInfo.duration}`}
                  {!campaignInfo.duration && 'Any'}
                </Typography>
                <Typography variant="body1">Duration</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.country && `${campaignInfo.country}`}
                  {!campaignInfo.country && 'Any'}
                </Typography>
                <Typography variant="body1">Location</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.gender && `${campaignInfo.gender}`}
                  {!campaignInfo.gender && 'Any'}
                </Typography>
                <Typography variant="body1">Gender</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.productCategory &&
                    `${campaignInfo.productCategory}`}
                  {!campaignInfo.productCategory && 'Any'}
                </Typography>
                <Typography variant="body1">Industry</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.influenceLevel === 'micro' && `Micro (100+)`}
                  {campaignInfo.influenceLevel === 'macro' && `Macro (10,000+)`}
                  {campaignInfo.influenceLevel === 'mega' && `Mega (100,000+)`}
                </Typography>
                <Typography variant="body1">Influence Level</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaignInfo.isPrivate && 'Yes'}
                  {!campaignInfo.isPrivate && 'No'}
                </Typography>
                <Typography variant="body1">Is Private</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {(campaignInfo.productUrl || campaignInfo.productPhotoUrl) && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <Typography variant="h4" align="left">
                Product
              </Typography>
              {campaignInfo.productPhotoUrl && (
                <div className={classes.productContainer}>
                  <img
                    src={campaignInfo.productPhotoUrl}
                    className={classes.productPhoto}
                  />
                </div>
              )}
              {campaignInfo.productUrl && (
                <Typography className={classes.productContainer} variant="h5">
                  <a
                    className={classes.productContainer}
                    href={`${
                      campaignInfo.productUrl.indexOf('http://') === 0 ||
                      campaignInfo.productUrl.indexOf('https://') === 0
                        ? campaignInfo.productUrl
                        : '//' + campaignInfo.productUrl
                    }`}
                    target="_blank"
                  >
                    Check out the product!
                  </a>
                </Typography>
              )}
            </Grid>
          </Paper>
        )}
        {campaignInfo.goals && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <div>
                <Typography variant="h4">Campaign Goals</Typography>
              </div>
              <div className={classes.goalsContainer}>
                <Typography>{campaignInfo.goals}</Typography>
              </div>
            </Grid>
          </Paper>
        )}
        {campaignInfo.brandStory && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <div>
                <Typography variant="h4">Brand Story</Typography>
              </div>
              <div className={classes.brandStoryContainer}>
                <Typography>{campaignInfo.brandStory}</Typography>
              </div>
            </Grid>
          </Paper>
        )}
        <div className={classes.buttons}>
          <Button onClick={backButtonClick} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={saveCampaignClick}
            className={classes.nextButton}
          >
            Create Campaign
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CampaignReview);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/CampaignReview.js